module.exports = "/assets/4e90f5c86bfa83ce3f810893d9e14743.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/GX.png
// module id = 1421
// module chunks = 0